import React from "react";
import { Phone, Users, Car } from "lucide-react";
import { FLEET, CONTACT } from "../mock";
import { Button } from "../components/ui/button";

const Fleet = () => {
  return (
    <section id="fleet" className="py-20 bg-[#fffaf3]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-amber-600 font-medium tracking-widest uppercase text-sm">
            Travel In Comfort
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-orange-900 mt-2">
            Our Fleet Of Cabs
          </h2>
          <div className="mx-auto mt-4 h-1 w-24 rounded-full bg-gradient-to-r from-amber-400 to-orange-600" />
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {FLEET.map((car) => (
            <div
              key={car.name}
              className="group rounded-3xl bg-white shadow-md hover:shadow-2xl transition-all duration-300 border border-amber-100 overflow-hidden"
            >
              <div className="h-44 bg-gradient-to-br from-orange-50 to-amber-100 flex items-center justify-center p-4">
                <img
                  src={car.image}
                  alt={car.name}
                  className="max-h-full object-contain group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs font-medium px-3 py-1 rounded-full bg-orange-100 text-orange-700">
                    {car.type}
                  </span>
                  <span className="flex items-center gap-1 text-sm text-stone-500">
                    <Users className="h-4 w-4" /> {car.seats}
                  </span>
                </div>
                <h3 className="font-display text-xl text-stone-800 mb-4 flex items-center gap-2">
                  <Car className="h-5 w-5 text-orange-600" /> {car.name}
                </h3>
                <a href={`tel:+91${CONTACT.primary}`}>
                  <Button
                    variant="outline"
                    className="w-full border-orange-300 text-orange-700 hover:bg-orange-600 hover:text-white rounded-full gap-2"
                  >
                    <Phone className="h-4 w-4" /> Book This Cab
                  </Button>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Fleet;
